var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stat",class:{'stat--active': _vm.filteredBy}},[_c('Icon',{attrs:{"type":`ios-${_vm.icon}`}}),_vm._v(" "+_vm._s(_vm._f("shorten")(_vm.statValue))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }